/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PartnerVisitListItemDto
 */
export interface PartnerVisitListItemDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'appointedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerVisitListItemDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'insertionTime': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'patientName': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'timeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'visitStatus'?: PartnerVisitListItemDtoVisitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerVisitListItemDto
     */
    'visitType'?: PartnerVisitListItemDtoVisitTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PartnerVisitListItemDtoVisitStatusEnum {
    Done = 'DONE',
    Cancelled = 'CANCELLED',
    Additional = 'ADDITIONAL',
    ToMove = 'TO_MOVE'
}
/**
    * @export
    * @enum {string}
    */
export enum PartnerVisitListItemDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


